<template>
  <section class="section" name="公司介绍">
    <div class="container">
      <a-typography-title :level="1">公司介绍</a-typography-title>
      <a-typography-title :level="5">COMPANY PROFILE</a-typography-title>
      <a-typography-paragraph>
        {{
          '星汉未来（Galaxy-Future）创立于2021年6月，作为一家AI应用平台厂商，' +
          '提供AI应用管理、AI算力管理等全方位AI平台服务，以及AI数字人、AI绘画等AI应用服务。' +
          '2023年，公司荣获“北京市专精特新中小企业”及“国家高新技术企业”称号。' +
          '凭借丰富的专利技术和不懈的产品创新，星汉未来致力于推动AI应用的落地和普及，让AI技术成为企业的增长新动力。'
        }}
      </a-typography-paragraph>
      <!--<div class="box_video" :class="{active:expand.active}">-->
      <!--  <video ref="video" :src="href.video"-->
      <!--         controls preload="metadata" />-->
      <!--  <i class="video_play"-->
      <!--     @click="clickPlayVideo" />-->
      <!--</div>-->
      <!--<a-typography-paragraph>-->
      <!--  {{-->
      <!--    '星汉未来入选2023年第三季度北京市专精特新中小企业，作为一家高新科技企业，星汉未来拥有雄厚的技术研发实力，被评选为中关村高新技术企业、2022中国数智化创新TOP50企业。' +-->
      <!--    '此外，其自主研发的数据物流引擎DTExpress、指标治理引擎CudgX、算力共享池、快速规格压测、快速流量压测等均获得发明专利授权，' +-->
      <!--    '云原生智能运维平台SchedulX、Serverless平台应用托管产品InfraPilot等产品已获得软著认证。'-->
      <!--  }}-->
      <!--</a-typography-paragraph>-->
      <a-typography-paragraph>
        {{
          '作为一家高新科技企业，星汉未来坚持技术创新，不断打造专业的技术产品服务力，' +
          '2022年被评选为中关村高新技术企业、2023年获得国家高新技术企业、北京市专精特新中小企业等荣誉。' +
          '这是企业在科技成果水平和产品技术含量取得里程碑式的荣誉，也是对企业技术实力的有力证明。'
        }}
      </a-typography-paragraph>
      <a-row class="box_image" type="flex" justify="space-around"
             :gutter="[20,10]">
        <a-col :xs="24" :md="8">
          <img alt="" :src="file.Image_12" />
        </a-col>
        <a-col :xs="24" :md="8">
          <img alt="" :src="file.Image_1" />
        </a-col>
        <a-col :xs="24" :md="8">
          <img alt="" :src="file.Image_13" />
        </a-col>
      </a-row>
      <a-typography-paragraph>
        {{
          '星汉未来注重核心技术自主研发及创新，' +
          '其自主研发的数据物流引擎DTExpress、指标治理引擎CudgX、快速规格压测、快速流量压测、算力共享池等均获得发明专利授权，' +
          '云原生智能运维平台SchedulX、Serverless平台应用托管产品InfraPilot等产品已获得软著认证。'
        }}
      </a-typography-paragraph>
      <a-row class="box_image" type="flex" justify="space-around"
             :gutter="[20,10]">
        <a-col :xs="24" :md="4">
          <img alt="" :src="file.Image_7" />
        </a-col>
        <a-col :xs="24" :md="4">
          <img alt="" :src="file.Image_8" />
        </a-col>
        <a-col :xs="24" :md="4">
          <img alt="" :src="file.Image_9" />
        </a-col>
        <a-col :xs="24" :md="4">
          <img alt="" :src="file.Image_10" />
        </a-col>
        <a-col :xs="24" :md="4">
          <img alt="" :src="file.Image_11" />
        </a-col>
      </a-row>
      <a-typography-paragraph>
        {{
          '同时，星汉未来致力于云原生落地，积极推动开源社区生态发展，' +
          '已正式入选成为FinOps产业推进方阵共建单位、开源 GitOps 产业联盟会员、FinOps 产业标准生态联盟首批会员。' +
          '2022年6月，经中国通信企业协会常务理事会评估，星汉未来正式加入中国通信企业协会，成为通信网络运营专业委员会会员单位。' +
          '2022年被评为2022中国数智化创新TOP50企业。'
        }}
      </a-typography-paragraph>
      <a-row class="box_image" :gutter="[20,10]">
        <a-col :xs="24" :md="8">
          <img alt="" :src="file.Image_4" />
        </a-col>
        <a-col :xs="24" :md="8">
          <img alt="" :src="file.Image_5" />
        </a-col>
        <a-col :xs="24" :md="8">
          <img alt="" :src="file.Image_6" />
        </a-col>
      </a-row>
    </div>
  </section>
  <section class="section" name="团队介绍">
    <div class="container">
      <a-typography-title :level="1">团队介绍</a-typography-title>
      <a-typography-title :level="5">TEAM INTRODUCTION</a-typography-title>
      <a-typography-paragraph>
        {{
          '星汉未来研发团队成员来自于微博、阿里、华为、字节等知名企业核心团队。' +
          'CEO 为前微博基础架构部总负责人，负责核心业务 10 年以上。'
        }}
      </a-typography-paragraph>
      <div class="box_team">
        <a-divider orientation="left">管理团队</a-divider>
        <div v-for="item in expand.team" class="team">
          <div class="team_name">
            {{ item.name }}<span>{{ item.position }}</span>
          </div>
          <ul>
            <li v-for="v in item.list">{{ v }}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="section" name="公司发展里程碑">
    <div class="container">
      <a-typography-title :level="1">公司发展里程碑</a-typography-title>
      <a-typography-title :level="5">COMPANY MILESTONES</a-typography-title>
      <a-timeline class="box_time">
        <a-timeline-item v-for="item in expand.time">
          <a-row>
            <a-col :xs="24" :md="5">
              <span>{{ item.date }}</span>
            </a-col>
            <a-col :xs="24" :md="19">
              {{ item.value }}
            </a-col>
          </a-row>
        </a-timeline-item>
      </a-timeline>
    </div>
  </section>
  <section class="section section_max" name="企业文化">
    <div class="container">
      <a-typography-title :level="1">企业文化</a-typography-title>
      <a-typography-title :level="5">CORPORATE CULTURE</a-typography-title>
      <a-row class="box_culture">
        <a-col :xs="24" :lg="8">
          <i />
          <p>使命</p>
          <p>
            让计算像电一样<br />
            随需使用
          </p>
        </a-col>
        <a-col :xs="24" :lg="8">
          <i />
          <p>愿景</p>
          <p>
            10年帮助10万企业<br />
            将计算效率提升10倍
          </p>
        </a-col>
        <a-col :xs="24" :lg="8">
          <i />
          <p>价值观</p>
          <p>
            客户第一，服务优先<br />
            创新创造价值<br />
            高人才密度带来创新<br />
            Keep Moving
          </p>
        </a-col>
      </a-row>
    </div>
  </section>
  <section class="section" name="联系我们">
    <div class="container">
      <a-typography-title :level="1">联系我们</a-typography-title>
      <a-typography-title :level="5">CONTACT US</a-typography-title>
      <a-row class="box_contact">
        <a-col :xs="24" :md="{ offset: 6, span: 12 }">
          <a-typography-title :level="5">
            <span>北京星汉未来</span>
            <br v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)" />
            <span>网络科技有限公司</span>
          </a-typography-title>
          <a-typography-paragraph>
            <PhoneOutlined :rotate="90" />
            <span>联系电话：010-53655900</span>
          </a-typography-paragraph>
          <a-typography-paragraph>
            <EnvironmentOutlined />
            <span>联系地址：北京市海淀区知春路23号</span>
          </a-typography-paragraph>
          <a-typography-paragraph>
            <MailOutlined />
            <span>联系邮箱：market@galaxy-future.com</span>
          </a-typography-paragraph>
        </a-col>
        <!--<a-col :xs="24" :md="12">-->
        <!--    <div class="qr">-->
        <!--        <img alt=""-->
        <!--             :src="file.ImageQR" />-->
        <!--        <p>关注微信公众号</p>-->
        <!--        <p>GalaxyFutureTech</p>-->
        <!--    </div>-->
        <!--</a-col>-->
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import {
  PhoneOutlined,
  EnvironmentOutlined,
  MailOutlined,
} from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import ImageLogo from '@resource/image/public/logo_black.png';
import ImageQR from '@resource/image/public/qr_public.png';
import Image_1 from '@resource/image/page/about/about_image_1.png';
import Image_2 from '@resource/image/page/about/about_image_2.png';
import Image_3 from '@resource/image/page/about/about_image_3.png';
import Image_4 from '@resource/image/page/about/about_image_4.png';
import Image_5 from '@resource/image/page/about/about_image_5.png';
import Image_6 from '@resource/image/page/about/about_image_6.png';
import Image_7 from '@resource/image/page/about/about_image_7.png';
import Image_8 from '@resource/image/page/about/about_image_8.png';
import Image_9 from '@resource/image/page/about/about_image_9.png';
import Image_10 from '@resource/image/page/about/about_image_10.png';
import Image_11 from '@resource/image/page/about/about_image_11.png';
import Image_12 from '@resource/image/page/about/about_image_12.png';
import Image_13 from '@resource/image/page/about/about_image_13.png';

export default {
  name: 'about_content',
  components: {
    PhoneOutlined,
    EnvironmentOutlined,
    MailOutlined,
  },
  data(): DataInterface {
    return {
      href: {
        video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/rencai-hzx.mp4'
      },
      file: {
        ImageLogo,
        ImageQR,
        Image_1,
        Image_2,
        Image_3,
        Image_4,
        Image_5,
        Image_6,
        Image_7,
        Image_8,
        Image_9,
        Image_10,
        Image_11,
        Image_12,
        Image_13
      },
      expand: {
        active: false,
        team: [
          {
            name: '刘道儒',
            position: '创始人&CEO',
            list: [
              '前微博基础架构部负责人、微博Feed系统技术负责人',
              '负责微博业务上云，包括多站点高可用、混合云等核心项目',
              '负责微博热点及全站稳定性维护，涉及高可用、A/B测试等子项目'
            ]
          }
        ],
        time: [
          {
            date: '2021年06月',
            value: '公司成立'
          },
          {
            date: '2021年07月',
            value: '天使轮融资，明势资本领投，初心资本跟投'
          },
          {
            date: '2021年08月',
            value: '天使+轮融资，经纬中国领投，明势资本、初心资本跟投，两轮累计融资近千万美元'
          },
          {
            date: '2021年11月',
            value: '发布核心引擎，启动开源社区建设'
          },
          {
            date: '2022年03月',
            value: '推出一站式云原生智能运维平台SchedulX'
          },
          {
            date: '2022年04月',
            value: '被评为中关村高新技术企业、FinOps产业推进方阵共建单位'
          },
          {
            date: '2022年06月',
            value: '成为中国通信企业协会会员'
          },
          {
            date: '2022年12月',
            value: '入选2022中国企业数智化创新TOP50'
          },
          {
            date: '2023年04月',
            value: '推出AI应用市场AIPilot'
          },
          {
            date: '2023年09月',
            value: '推出AI托管平台InfraPilot'
          },
          {
            date: '2023年12月',
            value: '入选2023年第三季度北京市专精特新中小企业'
          },
          {
            date: '2023年12月',
            value: '获得国家高新技术企业称号'
          },
          {
            date: '2024年03月',
            value: '推出星汉未来AI应用平台及AI应用一体机'
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 点击播放视频
     */
    clickPlayVideo() {
      this.expand.active = true;
      this.$refs.video && this.$refs.video.play();
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}public/';
@image: '@{src_image}page/about/';

.spriteAbout() {
  .bg('@{image}about.png', 1977px, 691px);
}

.ant-typography {
  margin-bottom: 30px;
}

.section {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  
  &.section_max {
    padding: 0;
  }
  
  &:nth-child(odd) {
    background: @color_7;
  }
  
  &:nth-child(even) {
    background: @color_white;
  }
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 100px 0;
    margin: 0 auto;
    
    > h1.ant-typography {
      position: relative;
      margin: 0 0 50px;
      .font(center, 50px, @color_1, 36px);
      
      &::before {
        content: "";
        display: block;
        .position(bottom, -20px);
        width: 24px;
        height: 2px;
        margin: 0 auto;
        background: #000000;
      }
    }
    
    > h5.ant-typography {
      margin: 0 0 50px;
      .font(center, 20px, @color_3, 18px);
    }
    
    > div.ant-typography {
      margin: 30px 0;
      .font(justify, 40px, @color_3, 18px);
      .fontSpacing(2px);
      // text-indent: 2em;
    }
  }
}

.box_video {
  overflow: hidden;
  position: relative;
  max-width: 850px;
  max-height: 470px;
  margin: 0 auto;
  border-radius: 5px;
  background-color: @color_black;
  
  &.active {
    &::before,
    &::after,
    .video_play {
      opacity: 0 !important;
      pointer-events: none !important;
    }
    
    video {
      opacity: 1;
    }
  }
  
  &::before,
  &::after,
  video,
  .video_play {
    .transition(opacity @time);
  }
  
  &::before,
  &::after {
    content: '';
    display: block;
    .position();
  }
  
  &::before {
    z-index: 1;
    .bg('@{image}about_video.jpg');
    background-size: cover;
  }
  
  &::after {
    z-index: 2;
    background: fade(@color_black, 30);
  }
  
  video {
    display: block;
    position: relative;
    width: 100%;
    opacity: 0;
  }
  
  .video_play {
    display: block;
    .position();
    z-index: 3;
    margin: auto;
    .bg('@{imagePublic}video_play.png', 128px, 128px);
    background-position: center;
    opacity: 0.85;
    cursor: pointer;
    
    &:hover {
      opacity: 1;
    }
  }
}

.box_image {
  img {
    display: block;
    max-width: 100%;
    max-height: 350px;
    margin: 0 auto;
  }
}

.box_team {
  .ant-divider {
    margin-top: 50px;
    .font(left, 50px, @color_6, 18px);
    
    &::before,
    &::after {
      border-top: 2px solid @color_6;
    }
  }
  
  .team {
    position: relative;
    max-width: 900px;
    margin: 20px auto 0;
    
    .team_name {
      .font(justify, 50px, @color_1, 18px, true);
      .fontSpacing(2px);
      
      span {
        margin-left: 15px;
      }
    }
    
    ul {
      li {
        position: relative;
        padding-left: 20px;
        .font(justify, 40px, @color_3, 18px);
        .fontSpacing(2px);
        
        &::after {
          @wh: 6px;
          content: "";
          display: block;
          .position(absolute, 18px, 0, 0, 5px);
          width: @wh;
          height: @wh;
          border-radius: @wh*0.5;
          background-color: @color_6;
        }
      }
    }
  }
}

.box_time {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  
  .ant-timeline-item {
    .font(justify, 30px, @color_3, 18px);
    
    span {
      .font(justify, 28px, @color_6, 18px, true);
      .fontSpacing(2px);
    }
    
    &:deep(.ant-timeline-item-head) {
      top: 3px;
    }
  }
}

.box_culture {
  position: relative;
  
  .ant-col {
    @h: 515px;
    overflow: hidden;
    float: left;
    position: relative;
    height: @h;
    
    &::before,
    &::after {
      content: "";
      display: block;
      .position();
      z-index: 0;
    }
    
    &::before {
      width: 400px;
      height: @h;
      margin: auto;
      .spriteAbout();
      .transition(transform @time);
    }
    
    &::after {
      background: @color_6;
      opacity: 0;
      .transition(opacity @time);
    }
    
    &:nth-child(1) {
      &::before {
        background-position: -767px 0;
      }
      
      > i {
        background-position: 0 0;
      }
    }
    
    &:nth-child(2) {
      &::before {
        background-position: -1172px 0;
      }
      
      > i {
        background-position: -102px 0;
      }
    }
    
    &:nth-child(3) {
      &::before {
        background-position: -1577px 0;
      }
      
      &:hover > p:nth-child(2) {
        .transform(translate(45px, -165px));
      }
      
      > i {
        background-position: -204px 0;
      }
    }
    
    &:hover {
      &::before {
        .transform(scale(1.2));
      }
      
      &::after {
        opacity: 0.7;
      }
      
      > i {
        .transform(translate(-60px, -70px) scale(0.6));
      }
      
      > p {
        &:nth-child(2) {
          .transform(translate(30px, -165px));
        }
        
        &:nth-child(3) {
          opacity: 1;
          .transform(translateY(-100px));
        }
      }
    }
    
    > i {
      @iwh: 97px;
      display: block;
      .position(top, 180px);
      z-index: 1;
      width: @iwh;
      height: @iwh;
      margin: 0 auto;
      .bg('@{image}about_icon.png', 301px, @iwh);
      .transition(transform @time);
    }
    
    > p {
      .position(top);
      z-index: 1;
      
      &:nth-child(2) {
        @ph: 50px;
        top: 300px;
        height: @ph;
        .font(center, @ph, @color_white, 40px);
        .transition(transform @time);
      }
      
      &:nth-child(3) {
        @style: transform @time, opacity @time;
        top: 330px;
        height: 168px;
        opacity: 0;
        .borderBox();
        .font(center, 50px, @color_white, 32px);
        .transition(@style);
      }
    }
  }
}

.box_contact {
  .ant-col {
    &:nth-child(1) {
      .anticon {
        margin-right: 10px;
        color: @color_6;
      }
      
      h5.ant-typography {
        display: block;
        .font(left, 40px, @color_6, 36px);
        margin-bottom: 55px;
      }
      
      div.ant-typography {
        display: block;
        color: @color_3;
        font-size: 18px;
      }
    }
    
    &:nth-child(2) {
      .qr {
        @img: 180px;
        position: relative;
        width: @img;
        margin: 0 auto;
        
        img {
          display: block;
          width: @img;
          height: @img;
          margin: 0 auto;
        }
        
        p {
          margin: 0;
          .font(center, 26px, @color_3, 18px);
        }
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .section {
    .container {
      padding: 50px 0;
      
      > h1.ant-typography {
        margin-bottom: 20px;
        .font(center, 40px, @color_1, 26px);
        
        &::before {
          .position(bottom, -10px);
        }
      }
      
      > h5.ant-typography {
        margin-bottom: 30px;
      }
    }
  }
  
  .box_video {
    max-width: 315px;
    max-height: 175px;
    
    .video_play {
      background-size: 80px 80px !important;
    }
  }
  
  .box_contact {
    .ant-col {
      &:nth-child(1) {
        h5.ant-typography {
          .font(center, 40px, @color_6, 26px);
          margin-bottom: 20px;
        }
        
        div.ant-typography {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>